module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cliente/operaciones/listado-cliente/listado-cliente.component.scss
// module id = ./src/app/cliente/operaciones/listado-cliente/listado-cliente.component.scss
// module chunks = main